import { TEMP_DEBOUNCE_MS } from '../config/app-config.js';
import { bandFor, temperatureF, type TempBand } from '../state/app-state.js';

export interface TemperatureHandlers {
  onBandCross: (band: TempBand) => Promise<void>;
}

export function renderTemperaturePanel(host: HTMLElement, h: TemperatureHandlers): void {
  host.innerHTML = `
    <div class="panel">
      <h2>Temperature sensor <span class="panel-unit">(°F)</span></h2>
      <div class="row">
        <label>
          <span>Reading</span>
          <input id="tp-input" type="number" min="-40" max="140" value="70" />
        </label>
        <span id="tp-band" class="band-chip"></span>
      </div>
    </div>`;
  const input = host.querySelector<HTMLInputElement>('#tp-input')!;
  const bandLabel = host.querySelector<HTMLSpanElement>('#tp-band')!;
  let lastBand: TempBand = bandFor(Number(input.value));
  bandLabel.textContent = lastBand;

  let timer: number | undefined;
  input.addEventListener('input', () => {
    if (timer) window.clearTimeout(timer);
    timer = window.setTimeout(async () => {
      const f = Number(input.value);
      temperatureF.set(f);
      const newBand = bandFor(f);
      bandLabel.textContent = newBand;
      if (newBand !== lastBand) {
        lastBand = newBand;
        await h.onBandCross(newBand);
      }
    }, TEMP_DEBOUNCE_MS);
  });
}
